<template>
  <section id="corresponsales" class="about-section">
    <vue-headful :title="title" />
    
    <div class="bg-layer">
      <div class="net-grid"></div>
      <div v-for="i in 8" :key="i" class="node" :style="nodeStyle(i)"></div>
      <div class="orb orb-1"></div>
      <div class="orb orb-2"></div>
    </div>

    <v-container class="content relative">
      <v-row justify="center" class="py-12 text-center">
        <v-col cols="12" md="10" lg="8" class="overflow-hidden">
          <div class="binary-scroll-container mb-4">
            <div class="binary-scrolling-text code-font primary--text opacity-50">
              01000011 01001111 01010010 01010010 01000101 01010011 01010000 01001111 01001110 01010011 01000001 01001100 01000101 01010011
            </div>
          </div>
          
          <div class="mb-8">
            <div class="code-font primary--text text-h6 tracking-widest mb-2">nic.ni</div>
            <h1 class="text-h3 text-md-h2 font-weight-black lh-1">
              <span class="d-block white--text">CORRESPONSALES</span>
              <span class="d-block nic-gradient mt-n2">AUTORIZADOS</span>
            </h1>
            <div class="scan-line my-6 mx-auto"></div>
          </div>
          <!-- <p class="code-font primary--text text-h6">Nuestros aliados estratégicos en el registro de dominios</p> -->
        </v-col>
      </v-row>

      <div class="py-12">
        <div class="grid-auto-fit gap-8">
          
          <div v-for="(item, i) in corresponsales" :key="i" class="glass-card hover-lift pa-8 relative overflow-hidden group">
            <v-icon x-large class="mb-6 pa-4 rounded-circle glass-bg transition-all cyan--text">
              {{ item.icon }}
            </v-icon>
            
            <h3 class="text-h4 font-weight-bold white--text mb-6">{{ item.nombre }}</h3>
            
            <div class="contact-info mt-auto">
              <div class="d-flex align-center mb-4">
                <div class="icon-ring mr-4">
                  <v-icon color="cyan">mdi-email-outline</v-icon>
                </div>
                <a :href="'mailto:' + item.correo" class="grey--text text--lighten-2 hover-cyan text-decoration-none text-h6 transition-all">
                  {{ item.correo }}
                </a>
              </div>

              <div class="d-flex align-center">
                <div class="icon-ring mr-4">
                  <v-icon color="cyan">mdi-web</v-icon>
                </div>
                <a :href="item.web" target="_blank" class="grey--text text--lighten-2 hover-cyan text-decoration-none text-h6 transition-all">
                  {{ item.web.replace('https://www.', '') }}
                </a>
              </div>
            </div>

            <div class="glow-bar"></div>
          </div>

        </div>
      </div>

      <div class="py-12">
        <div class="black rounded-lg overflow-hidden border-cyan max-w-md mx-auto">
          <div class="grey darken-4 pa-3 d-flex align-center gap-2 border-b-cyan">
            <div class="dot red"></div><div class="dot yellow"></div><div class="dot green"></div>
            <span class="code-font caption grey--text ml-2">system@nic.ni:/corresponsales</span>
          </div>
          <div class="pa-6 code-font green--text text--accent-3">
            <div><span class="cyan--text mr-2">nic@root:~$</span> ping -c 3 corresponsales.nic.ni</div>
            <div class="white--text ml-4 mt-2">
              64 bytes from dat-analytics.com: icmp_seq=1 ttl=118 time=12.4 ms<br>
              64 bytes from nicadigital.com: icmp_seq=2 ttl=118 time=14.1 ms<br>
              64 bytes from siticgroup.com: icmp_seq=3 ttl=118 time=13.8 ms<br>
              <br>
              <span class="green--text">--- corresponsales.nic.ni ping statistics ---</span><br>
              3 packets transmitted, 3 received, 0% packet loss.
            </div>
            <div class="d-flex align-center mt-4">
              <span class="cyan--text mr-2">nic@root:~$</span>
              <span class="typing-cursor">_</span>
            </div>
          </div>
        </div>
      </div>

    </v-container>
  </section>
</template>

<script>
import vueHeadful from "vue-headful";

export default {
  name: "Corresponsales",
  components: { vueHeadful },
  data: () => ({
    title: "CORRESPONSALES | NIC .NI",
    corresponsales: [
      { 
        nombre: "DAT-ANALYTIC", 
        correo: "info@dat-analytics.com", 
        web: "https://www.dat-analytics.com/",
        icon: "mdi-chart-box-outline" // Icono relacionado a Analytics
      },
      { 
        nombre: "NICADIGITAL", 
        correo: "ventas@nicadigital.com", 
        web: "https://www.nicadigital.com/",
        icon: "mdi-laptop" // Icono relacionado a Digital/Web
      },
      { 
        nombre: "SITIC", 
        correo: "ali.lopez@sitictecnology.net", 
        web: "https://siticgroup.com/",
        icon: "mdi-server-network" // Icono relacionado a Tecnología/Servidores
      }
    ]
  }),
  methods: {
    nodeStyle: (i) => ({
      left: `${50 + Math.cos(i)*40}%`, top: `${50 + Math.sin(i)*40}%`,
      animationDelay: `${i*0.5}s`
    })
  }
};
</script>

<style scoped>
/* Variables de la paleta */
:root { --primary: #00BCD4; --dark: #0a0f2b; }

.about-section { 
  background: linear-gradient(135deg, #0a0f2b, #1a1a2e); 
  min-height: 100vh; 
  overflow-x: hidden; 
  color: #fff; 
  font-family: 'Roboto', sans-serif; 
}
.code-font { font-family: 'Courier New', monospace; }
.relative { position: relative; z-index: 2; }

/* Animaciones y Efectos */
.binary-scroll-container { width: 100%; overflow: hidden; white-space: nowrap; }
.binary-scrolling-text { display: inline-block; animation: scroll-left 30s linear infinite; }
@keyframes scroll-left { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }

.bg-layer { position: absolute; inset: 0; z-index: 0; pointer-events: none; }
.net-grid { width: 100%; height: 100%; background: linear-gradient(90deg, rgba(0,188,212,0.05) 1px, transparent 1px), linear-gradient(0deg, rgba(0,188,212,0.05) 1px, transparent 1px); background-size: 50px 50px; }
.orb { position: absolute; border-radius: 50%; filter: blur(80px); opacity: 0.15; width: 300px; height: 300px; }
.orb-1 { background: #00BCD4; top: 10%; right: -10%; }
.orb-2 { background: #E040FB; bottom: 10%; left: -10%; }
.node { position: absolute; width: 6px; height: 6px; background: rgba(0,188,212,0.3); border-radius: 50%; animation: float 15s infinite linear; }
@keyframes float { 0% { transform: translateY(100vh); opacity:0;} 50% {opacity:1;} 100% {transform: translateY(-20vh); opacity:0;} }

/* Tipografía y Textos */
.nic-gradient { background: linear-gradient(45deg, #00BCD4, #3D5AFE); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
.scan-line { height: 2px; width: 200px; background: linear-gradient(90deg, transparent, #00BCD4, transparent); animation: scan 3s infinite; }
@keyframes scan { 0% {transform: translateX(-100%);} 100% {transform: translateX(100%);} }
.hover-cyan:hover { color: #00BCD4 !important; letter-spacing: 0.5px; }
.transition-all { transition: all 0.3s ease; }
.text-decoration-none { text-decoration: none; }

/* Tarjetas (Glassmorphism) */
.glass-card { 
  background: rgba(255,255,255,0.03); 
  backdrop-filter: blur(10px); 
  border: 1px solid rgba(255,255,255,0.1); 
  border-radius: 16px; 
  transition: 0.3s; 
  display: flex;
  flex-direction: column;
}
.glass-bg { background: rgba(255,255,255,0.1); }
.hover-lift:hover { transform: translateY(-5px); border-color: #00BCD4; box-shadow: 0 10px 30px rgba(0,188,212,0.15); }
.glow-bar { position: absolute; bottom:0; left:0; width:100%; height:3px; background: #00BCD4; transform: scaleX(0); transition: 0.3s; }
.hover-lift:hover .glow-bar { transform: scaleX(1); }
.icon-ring { width: 40px; height: 40px; border-radius: 50%; background: rgba(0,188,212,0.1); display: flex; align-items: center; justify-content: center; }

/* Layout Grid */
.grid-auto-fit { display: grid; grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); }
.gap-8 { gap: 32px; }
.max-w-md { max-width: 700px; }

/* Consola decorativa */
.border-cyan { border: 1px solid rgba(0,188,212,0.3); }
.border-b-cyan { border-bottom: 1px solid rgba(0,188,212,0.3); }
.dot { width: 10px; height: 10px; border-radius: 50%; }
.dot.red { background: #ff5f56; } .dot.yellow { background: #ffbd2e; } .dot.green { background: #27c93f; }
.typing-cursor { display: inline-block; width: 10px; height: 20px; background-color: #00BCD4; animation: blink 1s step-end infinite; }
@keyframes blink { 0%, 100% { opacity: 1; } 50% { opacity: 0; } }
</style>